import type { Ref } from 'vue';
import { ref, watchEffect } from 'vue';
type FlushComputeCallback<T> = () => T;

export const useFlushCompute = <T extends Record<string, unknown> | string | number | boolean>(
  f: FlushComputeCallback<T>
): Readonly<Ref<T>> => {
  const result = ref(f());
  watchEffect(
    () => {
      result.value = f();
    },
    {
      flush: 'post',
    }
  );

  return result as Readonly<Ref<T>>;
};
